import React, { Component } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import { initLenis, scrollToTop } from '@/lib/lenis';
import { useEffect } from 'react';
import Home from '@/pages/Home';
import Products from '@/pages/Products';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import Admin from '@/pages/Admin';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-night px-6 text-center">
          <div>
            <p className="font-serif text-4xl text-bone">Something spilled in the pantry.</p>
            <p className="mt-3 text-dune">Refresh the page to get back to the ledger.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    scrollToTop();
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  useEffect(() => {
    initLenis();
  }, []);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <motion.main
      key={location.pathname}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </motion.main>
  );
}

function PublicChrome({ children }) {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;
  return children;
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <div className="grain" aria-hidden="true" />
        <Navbar />
        <AnimatedRoutes />
        <PublicChrome>
          <Footer />
          <WhatsAppButton />
        </PublicChrome>
        <Toaster theme="dark" position="top-center" toastOptions={{ className: 'bg-coal border border-white/10 text-bone' }} />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
